import { render, staticRenderFns } from "./SocialHelp.vue?vue&type=template&id=3630ff76&"
import script from "./SocialHelp.vue?vue&type=script&lang=js&"
export * from "./SocialHelp.vue?vue&type=script&lang=js&"
import style0 from "./SocialHelp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports